export default {
  methods: {
    dTransportIdValid(id) {
      return id && id != null && id != 'None' ? true : false
    }
  }
}